import { Link, useLocation } from "react-router-dom";
import { Compass, ArrowRight, Activity } from "lucide-react";
import { SITE } from "../lib/site";
import { Button } from "../components/ui/button";
import { Seo } from "../components/Seo";
import { PublicHeader, PublicFooter } from "../components/public/PublicShell";
import { LEARN_ARTICLES } from "../lib/learnArticles";

const LINKS = [
  { to: "/", label: "Home" }, { to: "/tour", label: "Feature tour" }, { to: "/learn", label: "Guides & checklists" }, { to: "/faq", label: "FAQ" },
  { to: "/switch", label: "Compare & switch" }, { to: "/for-advisors", label: "For advisors" }, { to: "/trust", label: "Trust center" }, { to: "/vault", label: "Enter the vault" },
];

export default function NotFound() {
  const { pathname } = useLocation();
  const words = pathname.toLowerCase().split(/[^a-z]+/).filter((w) => w.length > 3);
  const suggested = LEARN_ARTICLES.filter((a) => words.some((w) => a.slug.includes(w) || a.title.toLowerCase().includes(w))).slice(0, 3);
  return (
    <div className="min-h-screen bg-background text-foreground" data-testid="not-found-page">
      <Seo title="Page not found" noindex />
      <PublicHeader />
      <main className="max-w-3xl mx-auto px-6 py-20">
        <div className="text-[10px] uppercase tracking-widest font-mono text-primary flex items-center gap-1.5"><Compass className="h-3.5 w-3.5" /> 404</div>
        <h1 className="font-serif text-4xl sm:text-5xl tracking-tight mt-2">That page isn't in the vault.</h1>
        <p className="mt-4 text-muted-foreground">The link may be old, or the page may have moved. Here's where people usually mean to go.</p>
        <div className="mt-8 flex flex-wrap gap-2">{LINKS.map((l) => <Button key={l.to} asChild variant="outline" className="rounded-full"><Link to={l.to} data-testid={`notfound-link-${l.to === "/" ? "home" : l.to.slice(1).replace(/\//g, "-")}`}>{l.label}</Link></Button>)}</div>
        <p className="mt-6 text-sm text-muted-foreground flex items-center gap-1.5" data-testid="notfound-status-hint"><Activity className="h-3.5 w-3.5 text-primary" /> Think something's broken on our side? <a href={SITE.statusUrl} target="_blank" rel="noopener noreferrer" className="text-primary hover:underline" data-testid="notfound-status-link">Check live status</a></p>
        {suggested.length > 0 && <section className="mt-12"><h2 className="font-serif text-2xl">Maybe you were looking for</h2><ul className="mt-4 space-y-2">{suggested.map((a) => <li key={a.slug}><Link to={`/learn/${a.slug}`} className="text-primary hover:underline inline-flex items-center gap-1">{a.title} <ArrowRight className="h-3 w-3" /></Link></li>)}</ul></section>}
      </main>
      <PublicFooter />
    </div>
  );
}
